<template>
  <v-menu
    v-model="isOpen"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="formattedValue"
        :disabled="$attrs.disabled"
        :label="label"
        :prepend-icon="$attrs.disabled ? undefined : 'mdi-calendar'"
        class="datefield"
        :class="{'multiple':multiple || range}"
        readonly
        :clearable="$attrs.clearable"
        :rules="$attrs.rules"
        :error-messages="error"
        v-bind="attrs"
        v-on="on"
        @click:clear="onClear"
      />
    </template>
    <v-date-picker
      v-model="localValue"
      scrollable
      :multiple="multiple"
      :range="range"
      :first-day-of-week="1"
      :min="minIso"
      :max="maxIso"
      :allowed-dates="filter"
      locale="fr-FR"
      @input="onInputDatepicker"
    />
  </v-menu>
</template>

<script>
import { format, parseISO } from 'date-fns'
import { fr } from 'date-fns/locale'
import { isOpenDay } from '@/utils/date'
export default {
  name: 'AgrialDatepicker',
  props: {
    value: {
      type: [String, Array],
      default: null
    },
    min: {
      type: [String, Date],
      default: undefined
    },
    max: {
      type: [String, Date],
      default: undefined
    },
    onlyOpenDays: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    multiple: {
      type: Boolean,
      default: false
    },
    range: {
      type: Boolean,
      default: false
    },
    displayFormat: {
      type: String,
      default: 'dd/MM/yyyy'
    },
    error: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      isOpen: false,
      localValue: this.value
    }
  },

  computed: {
    formattedValue () {
      return (this.multiple || this.range) && Array.isArray(this.localValue) ? this.formattedMultipleValue : this.formattedSingleValue
    },
    formattedMultipleValue () {
      let result = ''
      if (Array.isArray(this.localValue) && this.localValue.length > 0) {
        const arrayOfValues = this.localValue.map(v => format(parseISO(v), this.displayFormat, { locale: fr }))
        result = arrayOfValues.join(', ')
      }
      return result
    },
    formattedSingleValue () {
      return this.localValue && !Array.isArray(this.localValue) ? format(parseISO(this.localValue), this.displayFormat, { locale: fr }) : ''
    },
    minIso () {
      return this.min ? new Date(this.min).toISOString() : undefined
    },
    maxIso () {
      return this.max ? new Date(this.max).toISOString() : undefined
    }
  },

  watch: {
    value (newValue) {
      this.localValue = newValue
    }
  },

  methods: {
    onClear () {
      this.localValue = null
      this.$emit('input', null)
    },
    onInputDatepicker ($event) {
      this.isOpen = !!this.multiple
      this.$emit('input', $event)
    },
    isOpenDayFilter (value) {
      return isOpenDay(parseISO(value))
    },
    filter (value) {
      return this.onlyOpenDays ? this.isOpenDayFilter(value) : true
    }
  }
}
</script>

<style lang="scss" scoped>
.datefield {
  font-size: 14px;
  padding-top: 2px;
}
</style>
